import { Form, Formik, FormikProps } from 'formik';
import { useRef, useState } from 'react';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTheme } from 'styled-components';

import authApis from '../../../APIs/auth';
import {
  Button,
  FormContainer,
  Input,
  SelectDropdown,
  Typography,
} from '../../../designComponents';
import { InfoRowStyled } from '../../../style/reusableStyle';
import { requestAPI } from '../../../utils';
import { generatePassword } from '../../../utils/generateRandomPassword';
import { CreateUserStyled } from './style';
import userDataValidation from './validation';

const options = [
  {
    id: 1,
    value: 'FIREMAN',
    label: 'Fire Man',
  },
  {
    id: 2,
    value: 'DRAFTSMAN',
    label: 'Draft Man',
  },
];

interface initialValuesTypes {
  userType: string;
  userName: string;
  userEmail: string;
  userAddress: string;
  password: string;
  confirmPassword: string;
}
const CreateUser = () => {
  const formikRef = useRef<FormikProps<initialValuesTypes>>(null);

  const [initialValues, _setIntialValues] = useState<initialValuesTypes>({
    userType: '',
    userName: '',
    userEmail: '',
    userAddress: '',
    password: '',
    confirmPassword: '',
  });

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isClickedEyeButton, setIsClickedEyeButton] = useState(false);
  const theme = useTheme();
  const handleAddUser = async (values: initialValuesTypes) => {
    try {
      setLoading(true);

      await requestAPI(
        authApis.createUserByAdmin({
          department: values.userType,
          emailAddress: values.userEmail,
          password: values.password,
          contactInfo: {
            address1: values.userAddress,
          },

          fullName: values.userName,
        }),
      );
      setLoading(false);
      toast('User added successfully');
      navigate(-1);
    } catch (error: any) {
      setLoading(false);
      console.error(error);
      toast.error(error);
    }
  };

  const handleGenerateRandomPassword = () => {
    const password = generatePassword();
    if (formikRef.current) {
      formikRef.current.setFieldValue('password', password);
      formikRef.current.setFieldValue('confirmPassword', password);
    }
  };
  return (
    <CreateUserStyled>
      <Typography variant="title">Create User</Typography>
      <div className="form">
        <Formik
          onSubmit={handleAddUser}
          initialValues={initialValues}
          validationSchema={userDataValidation.User}
          innerRef={formikRef}
          enableReinitialize
        >
          {({ values, setFieldValue, errors, handleSubmit, touched }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <div className="form-inputs">
                  <InfoRowStyled className="input-text">
                    <FormContainer
                      label="User Type"
                      error={touched?.userType ? errors.userType : ''}
                      marginBottom="20px"
                    >
                      <SelectDropdown
                        options={options}
                        placeholder="Select user type"
                        selected={values.userType}
                        onSelect={(type: any) => {
                          setFieldValue('userType', type);
                        }}
                      />
                    </FormContainer>
                  </InfoRowStyled>
                  <InfoRowStyled className="input-text">
                    <FormContainer
                      label="User Name"
                      error={touched?.userName ? errors.userName : ''}
                      marginBottom="20px"
                    >
                      <Input
                        className="input"
                        name="userName"
                        value={values.userName}
                        onChange={(e) =>
                          setFieldValue('userName', e.target.value)
                        }
                        placeholder="Add User Name"
                      />
                    </FormContainer>
                  </InfoRowStyled>
                  <InfoRowStyled className="input-text">
                    <FormContainer
                      label="User Email"
                      error={touched?.userEmail ? errors.userEmail : ''}
                      marginBottom="20px"
                    >
                      <Input
                        className="input"
                        name="userEmail"
                        value={values.userEmail}
                        onChange={(e) =>
                          setFieldValue('userEmail', e.target.value)
                        }
                        placeholder="Add user email adress"
                      />
                    </FormContainer>
                  </InfoRowStyled>
                  <InfoRowStyled className="input-text">
                    <FormContainer
                      label="User Address"
                      error={touched?.userAddress ? errors.userAddress : ''}
                      marginBottom="20px"
                    >
                      <Input
                        className="input"
                        name="userAddress"
                        value={values.userAddress}
                        onChange={(e) =>
                          setFieldValue('userAddress', e.target.value)
                        }
                        placeholder="Add user adderess"
                      />
                    </FormContainer>
                    <FormContainer
                      label="Password"
                      error={touched?.password ? errors.password : ''}
                      marginBottom="20px"
                    >
                      <div
                        style={{
                          position: 'relative',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Input
                          className="input"
                          name="password"
                          type={isClickedEyeButton ? 'text' : 'password'}
                          value={values.password}
                          onChange={(e) =>
                            setFieldValue('password', e.target.value)
                          }
                          placeholder="Add password"
                        />
                        <div
                          style={{
                            position: 'absolute',
                            right: '20px',
                          }}
                          role="button"
                          onClick={() => setIsClickedEyeButton((prev) => !prev)}
                        >
                          {isClickedEyeButton ? (
                            <IoEyeOutline size={18} />
                          ) : (
                            <IoEyeOffOutline size={18} />
                          )}
                        </div>
                      </div>
                    </FormContainer>
                    <Button
                      onClick={handleGenerateRandomPassword}
                      variant="secondary"
                      bgColor={theme.colors.darkSlateGray.faded}
                    >
                      Generate Password
                    </Button>
                    <FormContainer
                      label="Confirm Password"
                      error={
                        touched?.confirmPassword ? errors.confirmPassword : ''
                      }
                      marginBottom="20px"
                    >
                      <div
                        style={{
                          position: 'relative',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Input
                          className="input"
                          name="confirmPassword"
                          type={isClickedEyeButton ? 'text' : 'password'}
                          value={values.confirmPassword}
                          onChange={(e) =>
                            setFieldValue('confirmPassword', e.target.value)
                          }
                          placeholder="Add confirm password"
                        />
                        <div
                          style={{
                            position: 'absolute',
                            right: '20px',
                          }}
                          role="button"
                          onClick={() => setIsClickedEyeButton((prev) => !prev)}
                        >
                          {isClickedEyeButton ? (
                            <IoEyeOutline size={18} />
                          ) : (
                            <IoEyeOffOutline size={18} />
                          )}
                        </div>
                      </div>
                    </FormContainer>
                  </InfoRowStyled>
                  {/* <InfoRowStyled className="input-text">
                    <Typography>Roles and Responsibilities</Typography>
                    <Typography variant="caption" fontColor="disableButton">
                      Please select the roles and corresponding responsibilities
                      that you wish to grant access to the user. You can modify
                      these permissions later.
                    </Typography>
                  </InfoRowStyled>
                  <div>
                    <InfoRowStyled className="checkbox">
                      <Checkbox />
                      <Typography>Review the entire escape plan.</Typography>
                    </InfoRowStyled>
                    <InfoRowStyled className="checkbox">
                      <Checkbox />
                      <Typography>
                        Submission of Escape Plan for Client Review.
                      </Typography>
                    </InfoRowStyled>
                    <InfoRowStyled className="checkbox">
                      <Checkbox />
                      <Typography>
                        Send notification to client after reviewing escape plan.
                      </Typography>
                    </InfoRowStyled>
                  </div> */}
                  <Button variant="secondary" type="submit" isLoading={loading}>
                    Continue
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </CreateUserStyled>
  );
};

export default CreateUser;
